export default __webpack_public_path__ + "622176e0aa0d7e5633a5566772b0c3ba.png";